import { LAST_30_DAYS_RANGE_PRESET_UTC } from 'cio/utils/workflow-metrics';
import moment from 'moment-timezone';

export const SEGMENT_MEMBERSHIP_RELEASE_TIMESTAMP = 1586390400; // 2020-04-09T00:00:00.000Z

export function getDefaultSegmentMembershipRange() {
  let defaultRange = LAST_30_DAYS_RANGE_PRESET_UTC.getRange();

  if (defaultRange.start.isBefore(moment.unix(SEGMENT_MEMBERSHIP_RELEASE_TIMESTAMP).utc())) {
    defaultRange.start = moment.unix(SEGMENT_MEMBERSHIP_RELEASE_TIMESTAMP).utc();
  }

  return defaultRange;
}
